import * as logMessageTypes from '../../consts/app/logMessageTypes';
import gamTimeouts from '../../consts/config/gamTimeouts';
import * as gamMethods from '../../consts/gam/gamMethods';
import {makeSelectIotDeviceFullData} from '../../state/selectors/consumer';
import {getState} from '../../state/store';
import helpers from '../../utils/helpers';
import authDataStoreService from '../auth/authDataStoreService';
import domService from '../domService';
import log from '../logger/log';
import storageService from '../storage/storageService';
import GamClient from './gamClient';

export const getGamGigyaToken = () => {
    try {
        const userData = storageService.getGamGigyaAccountDataFromStorage();

        if (userData) {
            const gigyaJWT = userData.gigyaJWT;

            if (gigyaJWT) return gigyaJWT;
        }
    } catch (e) {
        log.info(`gamGigyaService: GigyaToken parse error: ${e}`);
    }
    return null;
};

export const refreshGigyaToken = async () => {
    log.info(`gamGigyaService: refreshGigyaToken invoked`);

    let isGigyaTokenRefreshed = null;

    try {
        // eslint-disable-next-line no-undef
        if (typeof gigya === 'undefined' || gigya.accounts === 'undefined' || gigya.accounts.getJWT === 'undefined') {
            log.error(
                `gamGigyaService: refreshGigyaToken failed. gigya.accounts.getJWT not defined`,
                logMessageTypes.GAM
            );
            return false;
        }

        // eslint-disable-next-line no-undef
        gigya.accounts.getJWT({
            callback: async (accountInfo) => {
                if (accountInfo?.id_token && accountInfo.status === 'OK') {
                    let userData = storageService.getGamGigyaAccountDataFromStorage();

                    if (!userData) userData = {};

                    userData.gigyaJWT = accountInfo.id_token;
                    storageService.setGamGigyaAccountDataFromStorage(userData);

                    isGigyaTokenRefreshed = true;
                } else {
                    isGigyaTokenRefreshed = false;
                    log.info(
                        `gamGigyaService: refreshGigyaToken failed with errorCode: ${accountInfo?.errorCode}. Bad accountInfo from gigya.accounts.getJWT`
                    );
                }
            },
        });
    } catch (e) {
        isGigyaTokenRefreshed = false;
        log.error(`gamGigyaService: refreshGigyaToken failed. error: ${e}`, logMessageTypes.GAM);
    }

    let maxWait = gamTimeouts.GAM_GIGYA_REFRESH_TOKEN_TIMEOUT;

    while (isGigyaTokenRefreshed === null) {
        maxWait--;
        if (maxWait <= 0) {
            isGigyaTokenRefreshed = false;
            log.error(
                `gamGigyaService: refreshGigyaToken failed. gigya getJWT callback have not been called after 10 sec`,
                logMessageTypes.GAM
            );
        }

        await helpers.timeout(1000);
    }

    return isGigyaTokenRefreshed;
};

const getCodentify = (isHolder) => {
    const iotDevice = makeSelectIotDeviceFullData()(getState());

    if (isHolder) {
        return iotDevice?.holder?.codentifyOriginal;
    }

    const codentify = domService.getDeviceCodentifyFromRoot();

    if (!codentify) {
        const deviceCodentify = iotDevice?.device?.codentifyOriginal;

        if (deviceCodentify) return deviceCodentify;

        throw new Error('gamGigyaService: Device codentify does not exist in root element');
    }

    return codentify;
};

export const fetchGamToken = async (isHolder) => {
    const gigyaJWT = getGamGigyaToken();

    if (!gigyaJWT) throw new Error('gamGigyaService: GigyaToken does not exist in local storage');

    const codentify = getCodentify(isHolder);
    const requestConfig = {
        headers: {Authorization: 'Bearer ' + gigyaJWT},
        args: codentify,
    };

    const response = await new GamClient().callPut({methodName: gamMethods.MANAGE_DEVICE, requestConfig});

    if (response === true) {
        return true;
    }

    if (response) {
        const authToken = response.authtoken;

        authDataStoreService.setGamApiData(isHolder, authToken);
        return true;
    }

    return false;
};
